const { h, render, Component } = require('preact');

class TextParagraphInput extends Component {
  constructor(props) {
    super(props);
    this.readInput = this.readInput.bind(this)
    this.validateInput = this.validateInput.bind(this)
    this.readInput = this.readInput.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.populateInput = this.populateInput.bind(this)
    this.changeTextFieldParagraphState = this.changeTextFieldParagraphState.bind(this)
  }

  changeTextFieldParagraphState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  getInputHtmlElement() {
    var elementId = "text_paragraph_input" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  isInputGiven() {
    return this.getInputHtmlElement().value.trim().length > 0
  }

  readInput() {
    return this.getInputHtmlElement().value.trim()
  }

  validateInput() {
    if (this.props.attrs.required == "true") {
      return this.isInputGiven()
    }
    return true
  }

  isInputValid() {
    return this.isInputGiven()
  }

  populateInput() {
    var data = {}
    if (this.isInputGiven()) {
      var inputData = this.readInput()
      data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    }
    return data
  }

  componentDidMount() {
    var textLineElement = this.getInputHtmlElement()
    textLineElement.addEventListener("keyup", this.changeTextFieldParagraphState)
  }

  render() {
    let attrs = this.props.attrs
    let maxLength = 250
    let additional_attributes = attrs.additional_attributes
    if (additional_attributes) {
      let max_characters = additional_attributes.maximum_number_of_characters_or_digits
      if (max_characters) {
        if (max_characters.length > 0) {
          maxLength = parseInt(max_characters)
        }
      }
    }
    return (
      <div>
        <div class="row">
          <label for="">
            <strong id='ticket_description'>
              {attrs.label}
              {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
            </strong>
          </label>
          <textarea class="description support_textbox p10" style="font-size: 14px;" name="description" cols="80"
                    rows="10" placeholder="" aria-label="Description" id={"text_paragraph_input" + attrs.counter}></textarea>
        </div>
        <div class="row credit_card_warning invalid-input error initially-hidden">
          {I18n.translate('js.modules.support.invalid_description')}
          <span class="mandatory-field">*</span>
        </div>
      </div>
    )
  }
}
module.exports = TextParagraphInput
